import { useQuery } from '@tanstack/react-query';
import { marketing } from '@/lib/supabase/marketing';
import type { Outlet } from '@/types/domain';

export function useOutlets() {
  return useQuery({
    queryKey: ['outlets'],
    queryFn: async (): Promise<Outlet[]> => {
      const { data, error } = await marketing
        .from('outlets')
        .select('id, name, city, type, swiggy_id, zomato_id, google_place_id, meta_page_id')
        .order('name');
      if (error) throw error;
      return (data ?? []) as Outlet[];
    },
    staleTime: 10 * 60_000,
  });
}

export function useOutletCapabilities(outletId: string | 'all') {
  const { data } = useOutlets();
  if (outletId === 'all') {
    return { dineIn: true, qsr: true, aggregator: true, meta: true };
  }
  const outlet = data?.find((o) => o.id === outletId);
  if (!outlet) {
    return { dineIn: false, qsr: false, aggregator: false, meta: false };
  }
  return {
    dineIn: outlet.type === 'dine_in',
    qsr: outlet.type === 'qsr',
    aggregator: outlet.type === 'qsr',
    meta: Boolean(outlet.meta_page_id),
  };
}
